import { assert } from "@/lib/utils";
import { useAuthenticationStore } from "@/store/authentication";

export function useSessionUser() {
  const user = useAuthenticationStore((store) => store.user);
  assert(user, "User is not authenticated");
  return user;
}

export function useSession() {
  const user = useAuthenticationStore((state) => state.user);
  const organization = useAuthenticationStore((state) => state.organization);
  const customer = useAuthenticationStore((state) => state.profile.customer);
  const company = useAuthenticationStore((state) => state.profile.company);

  assert(user, "User is not authenticated");
  assert(organization, "User is not part of any organization");
  assert(customer, "User profile is not available");
  assert(company, "Company profile is not available");

  return { user, organization, profile: { customer, company } };
}
